import { render, staticRenderFns } from "./上蔡轮播新闻.vue?vue&type=template&id=d3cda87a&scoped=true"
import script from "./上蔡轮播新闻.vue?vue&type=script&lang=js"
export * from "./上蔡轮播新闻.vue?vue&type=script&lang=js"
import style0 from "./上蔡轮播新闻.vue?vue&type=style&index=0&id=d3cda87a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3cda87a",
  null
  
)

export default component.exports